import { lazyLoadComponent } from '@/utils/helper'

// import Roles from '@/utils/role'
const extUrlOnboardingPortal = { template: '' }
const extUrlOnboardingPortalURL = 'https://forms.office.com/Pages/ResponsePage.aspx?id=cTXzkw9Vz0Own80zEzjQhrRWppKs8BhDnZzUzgkus8JUQlNWWEUxTEs0TkI0SVc0OVlBT0FCNUIyVi4u'
const extViewHowToGuidesURL = 'https://dxc.whatwesell.bigtincan.com/page/57738f7a-43c3-43ce-9c0d-43961235aa2f'
const extOppregGuideURL = window.location.origin + '/DXC+AWS+Opportunity+Registration+Guide.pdf'
const extOnboardingGuideURL = window.location.origin + '/DXC+AWS+Account+Onboarding+Guide.pdf'
const extDefinitionAWSAccountURL = window.location.origin + '/Definitions_DXC+External_DXC+Internal+AWS+Account.pdf'
const extIWOWBSCreationProcessURL = window.location.origin + '/IWO+WBS+Creation+Process.pdf'


// init default route paths
export default [
  {
    path: '/',
    component: lazyLoadComponent('user/oppreg/Home'),
    name: 'Welcome to AWS Practice Galaxy Landing Page',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/request-oppreg/external-oppreg',
    component: lazyLoadComponent('user/oppreg/ExternalOppReg'),
    name: 'AWS Opportunity Registration',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/request-oppreg/workload-submission-confirmation',
    component: lazyLoadComponent('user/oppreg/ExternalOppRegConfirmation'),
    name: 'AWS Opportunity Registration Workload Confirmation',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      fail: '/404.html'
    }
  },
  // {
  //   path: '/request-oppreg/new-workload-to-existing-opportunity',
  //   component: lazyLoadComponent('user/oppreg/NewWorkLoadOpp'),
  //   name: 'AWS Opportunity Registration to Existing Opportunity',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'user',
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },

  // {
  //   path: '/request-oppreg/new-workload-or-existing-client',
  //   component: UserOppregNewWorkloadClient,
  //   name: 'AWS Opportunity Registration Existing Client',
  //   meta: {
  //     requiresAuth: true,
  //     permission: [],
  //     fail: '/404.html'
  //   }
  // },
  // AGAM-557 - Hide unused modules

  {
    path: '/request-oppreg/view-all-requests',
    component: lazyLoadComponent('user/oppreg/ViewAllRequest'),
    name: 'View All Requests',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/request-oppreg/update-discount',
    component: lazyLoadComponent('user/oppreg/UpdateDiscountQualification'),
    name: 'Update Discount Qualification',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/request-aws-account/new-account-for-registered-opportunity',
    component: lazyLoadComponent('user/awsacct/NewAcctForNewClient'),
    name: 'Request New Account for Registered Opportunity',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/request-aws-account/request-new-account-for-new-client',
    component: lazyLoadComponent('user/awsacct/NewAcctRequest'),
    name: 'Request New Account For New Client',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/request-aws-account/request-new-account-for-existing-client',
    component: lazyLoadComponent('user/awsacct/NewAcctForExistingClient'),
    name: 'Request New Account For Existing External Client',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
      fail: '/404.html'
    }
  },
  {
    path: '/request-aws-account/request-new-account-for-internal-client',
    component: lazyLoadComponent('user/awsacct/NewAcctForInternalClient'),
    name: 'Request New Account For DXC Internal Usage',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
      fail: '/404.html'
    }
  },
  {
    path: '/request-aws-account/request-new-training-account',
    component: lazyLoadComponent('user/awsacct/NewAcctForInternalClient'),
    name: 'Request New Training Account',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      fail: '/404.html'
    }
  },
  {
    path: '/list-aws-account/view-my-requests',
    component: lazyLoadComponent('user/listawsacct/ViewMyRequests'),
    name: 'View my Requests',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: [],
      // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
      fail: '/404.html'
    }
  },
  // AGAM-557 - Hide unused modules
  // {
  //   path: '/request-aws-account/new-account-for-registered-opportunity',
  //   component: UserAwsNewAccount,
  //   name: 'Request New Account for Registered Opportunity',
  //   meta: {
  //     requiresAuth: true,
  //     permission: Roles.User,
  //     fail: '/404.html'
  //   }
  // }
  // AGAM-557 - Hide unused modules
  // {
  //   path: '/how-to-guides/view-how-to-guides',
  //   beforeEnter () { window.open(extViewHowToGuidesURL), target = '_blank' },
  //   component: extUrlOnboardingPortal,
  //   name: 'View How-to-Guides',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'user',
  //     permission: 'public',
  //     fail: '/404.html'
  //   }
  // },
  {
    path: '/how-to-guides/download-oppreg-guide',
    beforeEnter () { window.open(extOppregGuideURL), target = '_blank' },
    component: extUrlOnboardingPortal,
    name: 'View and Download Guides',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      fail: '/404.html'
    }
  },
  {
    path: '/how-to-guides/download-account-onboarding-guide',
    beforeEnter () { window.open(extOnboardingGuideURL), target = '_blank' },
    component: extUrlOnboardingPortal,
    name: 'View How-to-Guides',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      fail: '/404.html'
    }
  },
  {
    path: '/how-to-guides/download-definition-aws-account',
    beforeEnter () { window.open(extDefinitionAWSAccountURL), target = '_blank' },
    component: extUrlOnboardingPortal,
    name: 'View How-to-Guides',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      fail: '/404.html'
    }
  },
  {
    path: '/how-to-guides/download-iwo-wbs-creation-process',
    beforeEnter () { window.open(extIWOWBSCreationProcessURL), target = '_blank' },
    component: extUrlOnboardingPortal,
    name: 'View How-to-Guides',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      fail: '/404.html'
    }
  },
  // {
  //   path: '/request-new-masterpayer',
  //   component: lazyLoadComponent('user/RequestNewMasterpayer'),
  //   name: 'Request New Masterpayer',
  //   meta: {
  //     requiresAuth: true,
  //     view: 'user',
  //     permission: 'public',
  //     // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
  //     fail: '/404.html'
  //   }
  // },
  {
    path: '/masterpayer-request/new',
    component: lazyLoadComponent('user/masterpayerRequest/RequestNewMasterpayer'),
    name: 'Request New Masterpayer',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
      fail: '/404.html'
    }
  },
  {
    path: '/masterpayer-request/view',
    component: lazyLoadComponent('user/masterpayerRequest/ViewRequest'),
    name: 'View All Request',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
      fail: '/404.html'
    }
  },
  {
    path: '/masterpayer-request/view/:id',
    component: lazyLoadComponent('user/masterpayerRequest/ViewRequestDetail'),
    name: 'View Request Detail',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
      fail: '/404.html'
    }
  },
  {
    path: '/request-managed-services/list',
    component: lazyLoadComponent('user/requestManagedServices/ViewRequest'),
    name: 'Customer Owned Accounts - Request Managed Svcs',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      fail: '/404.html'
    }
  },
  {
    path: '/request-managed-services/new',
    component: lazyLoadComponent('user/requestManagedServices/RequestNewManageServices'),
    name: 'Customer Owned Accounts - Request Managed Svcs',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      fail: '/404.html'
    }
  },
  {
    path: '/attestation/single',
    component: lazyLoadComponent('user/attestation/Attestation'),
    name: 'Single Account Attestation',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
      fail: '/404.html'
    }
  },
  {
    path: '/attestation/bulk',
    component: lazyLoadComponent('user/attestation/BulkAttestation'),
    name: 'Bulk Account Attestation',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
      fail: '/404.html'
    }
  },
  {
    path: '/attestation/new',
    component: lazyLoadComponent('user/attestation/AttestationNew'),
    name: 'New Attestation',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      // permission: [Roles.User, Roles.OppRegAdmin, Roles.ReadOnly],
      fail: '/404.html'
    }
  },
  {
    path: '/register-customer-owned-accts/new',
    component: lazyLoadComponent('user/registerCustomerOwnedAccts/CustomerOwnedAwsAccounts'),
    name: 'Create New Request',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      fail: '/404.html'
    }
  },
  {
    path: '/register-customer-owned-accts/list',
    component: lazyLoadComponent('user/registerCustomerOwnedAccts/ViewCustomerOwnedAwsAccounts'),
    name: 'View All Requests',
    meta: {
      requiresAuth: true,
      view: 'user',
      permission: 'public',
      fail: '/404.html'
    }
  },
]
